import imageCompression from 'browser-image-compression';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const compressFile = async (path: File) => {
  const compressedBlob = await imageCompression(path, {preserveExif: true});
  const compressedFile = new File(
    [compressedBlob],
    path.name || compressedBlob.name,
    {
      type: compressedBlob.type,
      lastModified: Date.now(),
    },
  );
  return compressedFile;
};
